import React, { PropTypes } from 'react';

import Goals from 'containers/Goals';
import { GoalShape } from 'entities';
import './style.scss';

const FeedGoals = (props) => {
  const {
    title,
    goals
  } = props;

  return (
    <div className="FeedGoals">
      <h4>{title}</h4>
      <Goals goals={goals} source={process.env.KOOTH_USER_FEED} />
    </div>
  );
};

FeedGoals.propTypes = {
  title: PropTypes.string,
  goals: PropTypes.arrayOf(GoalShape)
};

export default FeedGoals;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Feed/FeedGoals/index.js
 **/